module.exports = __webpack_public_path__ + "img/play.0495e45e.svg";